import { useQuery } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useThresholds = () => {
	return useQuery({
		queryKey: ["biometric-thresholds"],

		queryFn: () => EndpointsService.dataRetriever.getBiometricThresholds(),
	});
};
